import styled from 'styled-components';

const ApplicationButtonStyle = styled.div`
	--layoutGap: var(--sp1-5x);
	--appBlockGap: var(--sp1x);
	--appBlockBorderRadius: var(--sp4x);
	--appBlockPadding: var(--sp1-5x) var(--sp3x);
	--iconSize: var(--sp4x);

	display: flex;
	flex-wrap: wrap;
	gap: var(--layoutGap);

	.application-button-item {
		border-radius: var(--appBlockBorderRadius);
		border: 1px solid rgba(255, 255, 255, 0.4);
		background-color: rgba(255, 255, 255, 0);
		overflow: hidden;
		width: fit-content;

		transition: border-color var(--trTime) ease-out;

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					border-color: var(--mainColor);
				}
			}
		}
	}

	.app-block {
		display: flex;
		gap: var(--appBlockGap);
		padding: var(--appBlockPadding);
	}

	.app-icon {
		font-size: var(--iconSize);
	}

	&.is-secondary {
		gap: var(--sp1-5x);

		.app-block {
			align-items: center;
			gap: var(--sp0-5x);
			padding: var(--sp1x) var(--sp3x) var(--sp1x) var(--sp2x);
		}

		.application-button-item {
			border: 1px solid var(--neutral150);
			background-color: var(--mainColor);

			transition: border-color var(--trTime) ease-out;

			@media (pointer: fine) {
				@media (hover: hover) {
					&:hover {
						border-color: var(--neutral1000);
					}
				}
			}
		}

		.item-description {
			color: var(--neutral1000);
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		&.is-secondary {
			.app-block {
				padding: var(--sp1x) var(--sp3x) var(--sp1x) var(--sp2x);
			}

			.app-icon {
				font-size: var(--sp3x);
			}
		}
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		&.is-secondary {
			.app-block {
				padding: var(--sp1x) var(--sp2x) var(--sp1x) var(--sp1-5x);
			}
		}
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		&.is-secondary {
			.app-icon {
				font-size: var(--sp2-5x);
			}
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--layoutGap: var(--sp1x);
		--appBlockPadding: var(--sp1x) var(--sp2-5x);

		&.is-secondary {
			gap: var(--sp1x);
		}
	}
`;

export default ApplicationButtonStyle;
